import styled, { css } from "styled-components";
import { Box, colors, lighten } from "@mui/material";
import "@fontsource/inria-serif";
import "@fontsource/league-spartan";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

const common_btn = (props: { colormatrix: TemplateColorObject }) => css`
	background: ${props.colormatrix.button.background};
	color: ${props.colormatrix.button.text};
	padding: 5px 15px;
	font-family: var(--league), sans-serif;
	&.Mui-disabled {
		background: ${colors.grey[300]};
	}
`;

export const TemplateWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	overflow: hidden;
	.section_01 {
		position: relative;
		margin-bottom: 70px;
		.section_content {
			position: relative;
			top: 0;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 10px;
		}
		.main_image_wrapper {
			position: relative;
			min-height: 400px;
			padding: 3px;
			.cloud {
				position: absolute;
				background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 1) 90%);
				width: 100%;
				height: 60px;
				z-index: 1;
				bottom: 0;
			}
			img {
				width: 100%;
			}
		}

		.save_date_wrapper {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 100%;
			padding: 10px 15px;
			.partners_text {
				font-family: var(--inriaSerif), sans-serif;
				font-weight: bold;
				z-index: 1;
				font-size: 26px;
			}
			.date {
				font-weight: bold;
				font-size: 24px;
				color: ${props => props.colormatrix.font.primary};
				font-family: var(--league), sans-serif;
			}
			.info {
				font-family: var(--league), sans-serif;
				font-size: 14px;
				font-weight: semiBold;
				margin: 3px;
			}
			button {
				${props => common_btn(props)}
				margin-top: 10px;
			}
		}
	}

	.section_02 {
		background: ${props => props.colormatrix.main};
		padding: 45px 30px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.title {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 28px;
			color: ${props => props.colormatrix.font.tertiary};
			margin-bottom: 10px;
		}
		.count_down_wrapper {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.counter_boxes_wrapper {
				display: flex;
				padding: 10px;
				.counter_box_wrapper {
					display: flex;
					flex-direction: column;
					margin: 10px;
					align-items: center;
					.counter_box {
						color: ${props => props.colormatrix.font.tertiary};
						display: flex;
						justify-content: center;
						padding: 5px 20px;
						border-radius: 5px;
						font-family: var(--inriaSerif), sans-serif;
						font-size: 32px;
						min-width: 25px;
					}
					p {
						font-family: var(--inriaSerif), sans-serif;
						font-size: 22px;
						color: ${props => props.colormatrix.font.tertiary};
					}
				}
			}
		}
	}
	.section_03 {
		background-image: url("https://storage.googleapis.com/public_viteslink_storage/images/invitation03/frame.png");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		position: relative;

		.section_overlay {
			position: absolute;
			width: 100%;
			height: 100%;
			background: ${props => props.colormatrix.overlay};
			//background: linear-gradient(180deg, rgba(255, 245, 245, 1) 0%, rgba(255, 255, 255, 1) 100%);
			opacity: 0.3;
			z-index: 0;
		}
		.section_content {
			position: relative;
			top: 0;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 60px 10px;

			.cloud {
				position: absolute;
				background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 1) 90%);
				width: 100%;
				height: 60px;
				z-index: 1;
				bottom: 0;
			}
			.quran {
				margin: 30px 0;
				font-size: 30px;
				font-family: var(--quran), sans-serif;
				text-align: center;
				line-height: 1.2;
			}
			.main_intro {
				font-family: var(--inriaSerif), sans-serif;
				font-size: 16px;
				text-align: center;
				padding: 5px 20px;
			}
			.main_sub_intro {
				font-family: var(--inriaSerif), sans-serif;
				font-size: 22px;
				color: ${lighten("#000", 0.2)};
				margin: 15px 0;
			}
			.partner_frame_wrapper {
				background: #fff;

				border-radius: 15px;
				img {
					border-radius: 15px;
					box-shadow: 0 0 2px 2px #979797;
					height: 220px;
				}
			}

			.partner_name {
				font-family: var(--league), sans-serif;
				font-size: 24px;
			}
			.and {
				font-family: var(--league), sans-serif;
				font-size: 24px;
				margin: 20px 0;
			}
		}
	}

	.section_04 {
		background-image: url("https://storage.googleapis.com/public_viteslink_storage/images/invitation03/quran_frame.png");
		background-size: auto;
		background-position: center;
		background-repeat: no-repeat;
		position: relative;
		width: 100%;
		height: 260px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		.quran_start {
			font-family: var(--quran);
			font-size: 22px;
			text-align: center;
			font-weight: bold;
			margin-bottom: 25px;
			direction: rtl;
		}
		.quran {
			font-family: var(--quran);
			font-size: 22px;
			text-align: center;
			font-weight: bold;
			padding: 0 15px;
			direction: rtl;
		}
		.quran_end {
			font-family: var(--quran);
			font-size: 22px;
			text-align: center;
			margin-top: 25px;
			font-weight: bold;
			direction: rtl;
		}
	}

	.section_05 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		.image_wrapper {
			position: relative;
			.cloudUp {
				position: absolute;
				background: linear-gradient(0deg, transparent, rgba(255, 255, 255, 1) 60%);
				width: 100%;
				height: 40px;
				z-index: 1;
				top: 24px;
			}
			.cloudDown {
				position: absolute;
				background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 1) 60%);
				width: 100%;
				height: 40px;
				z-index: 1;
				bottom: 20px;
			}
			.love_story_wrapper {
				width: 100%;
				display: flex;
				justify-content: center;
				position: relative;
				margin: 30px 0;

				.story_image {
					max-width: 350px;
					background: #fff;
				}
			}
		}

		.section_title {
			font-family: var(--inriaSerif), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 28px;
			margin-top: 35px;
		}

		.stories {
			display: flex;
			flex-direction: column;
			margin-top: 30px;
			margin-bottom: 50px;
			min-width: 330px;
			.story {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 10px 20px;
				p {
					font-family: var(--inter), sans-serif;
					font-size: 20px;
					font-weight: 400;
					text-align: center;
				}
				hr {
					width: 100%;
					background-color: #000;
					margin: 10px 0;
				}
				p:first-child {
					margin: 10px 0;
				}
				p:last-child {
					color: ${lighten("#000", 0.4)};
				}
			}
		}
	}

	.section_06 {
		display: flex;
		flex-flow: column;
		align-items: center;
		position: relative;
		margin-bottom: 25px;
		padding: 10px;

		.section_title {
			font-family: var(--inriaSerif), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 32px;
			margin-top: 35px;
		}
		.flower_07 {
			position: absolute;
			left: 0;
			top: 0;
		}
	}

	.section_07 {
		background-image: url("https://storage.googleapis.com/public_viteslink_storage/images/invitation03/frame.png");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		position: relative;
		padding: 10px;
		.section_overlay {
			position: absolute;
			width: 100%;
			height: 100%;
			background: rgb(255 245 245);
			background: linear-gradient(180deg, rgba(255, 245, 245, 1) 0%, rgba(255, 255, 255, 1) 100%);
			opacity: 0.3;
			z-index: 0;
		}

		.section_content {
			padding-top: 40px;
			position: relative;
			top: 0;
			z-index: 1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		.section_title {
			font-family: var(--inriaSerif), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 32px;
		}

		.comment_text {
			font-family: var(--inter), sans-serif;
			font-size: 22px;
			padding: 5px;
		}
		.comment_sub_text {
			font-family: var(--inter), sans-serif;
			font-size: 14px;
			font-weight: 500;
			color: ${props => props.colormatrix.font.secondary};
			text-align: center;
			padding: 0 30px;
		}
	}
	.section_08 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		.section_title {
			font-family: var(--inriaSerif), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 30px;
			margin-top: 85px;
		}
		.location_text {
			font-family: var(--inter), sans-serif;
			text-align: center;
			padding: 5px;
		}
		button {
			margin: 15px;
			${props => common_btn(props)}
			padding: 10px 40px;
		}

		.partner_04_wrapper {
			border-radius: 20px;
			background: #fff;
			position: relative;
			box-shadow: 0 0 2px 2px #ebebeb;
			display: flex;
			.partner_04 {
				width: 220px;
				border-radius: 20px;
			}
		}
		.partners_text {
			font-family: var(--inter), sans-serif;
			font-weight: bold;
			//z-index: 1;
			font-size: 26px;
		}
		.conclusion_text {
			font-family: var(--inter), sans-serif;
			font-size: 16px;
			font-weight: 500;
			text-align: center;
			padding: 10px;
		}
	}
	.section_09 {
		background: ${props => props.colormatrix.main};
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		padding: 20px 0;

		p {
			color: #fff;
			margin: 10px 0;
		}
		.social {
			cursor: pointer;
			text-decoration: none;
		}
	}
`;
